'use client';

import { Toaster, TooltipProvider } from 'ui';

interface UIProvidersProps {
  children: React.ReactNode;
}

export function UIProviders({ children }: UIProvidersProps) {
  return (
    <TooltipProvider>
      <Toaster closeButton position="bottom-center" richColors />
      {children}
    </TooltipProvider>
  );
}
